import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter,
    Button, Flex, Box, Input, FormLabel, Spinner
} from "@chakra-ui/react";
import { FileCheck } from "lucide-react";

import React, { useState } from 'react';

import useCustomToast from "../../utils/toastHelper";
const BookDemoModal = ({ isOpen, onClose }) => {

    const { showSuccessToast, showErrorToast } = useCustomToast();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


        if (!firstName || !lastName || !email || !mobile) {
            showErrorToast("Please fill all the fields before submitting.");
            return;
        }

        if (!emailRegex.test(email)) {
            showErrorToast("Please enter a valid email address.");
            return;
        }

        try {
            setIsLoading(true); // Start loading
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/book-demo`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    firstName,
                    lastName,
                    email,
                    number: mobile,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showSuccessToast("Thank you! We'll contact you shortly.");
                //  reset form fields here
                setFirstName("");
                setLastName("");
                setEmail("");
                setMobile("");
            } else {
                showErrorToast(data.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            showErrorToast("Failed to send request. Please try again.");
        }
        finally {
            setIsLoading(false); // Stop loader once done
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent mt="10vh">
                <ModalHeader>Book A Demo</ModalHeader>
                <ModalCloseButton color="red.500" _hover={{ bg: "transparent" }} />

                <ModalBody>
                    <Flex direction="column" gap="1rem">
                        <Flex gap="1rem">
                            <Box flex="1">
                                <FormLabel>First name</FormLabel>
                                <Input
                                    placeholder="First name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </Box>
                            <Box flex="1">
                                <FormLabel>Last name</FormLabel>
                                <Input
                                    placeholder="Last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </Box>
                        </Flex>
                        <Box>
                            <FormLabel>Email</FormLabel>
                            <Input
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Box>
                        <Box>
                            <FormLabel>Mobile Number</FormLabel>
                            <Input
                                placeholder="9199999999"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                            />
                        </Box>
                    </Flex>
                </ModalBody>

                <ModalFooter>

                    <Button
                        colorScheme="purple"
                        mr={3}
                        onClick={handleSubmit}
                        rightIcon={isLoading ? <Spinner size="sm" /> : <FileCheck size={18} />}
                        isLoading={isLoading} // Enable Chakra's built-in button loader
                        loadingText="Submitting..."
                    >
                        {isLoading ? 'Submitting...' : 'Submit'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default BookDemoModal;
